/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 22V13M12 13L8.5 16.5M12 13L15.5 16.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12 2C7.74741 2 4.3 5.55187 4.3 9.93333C4.3 9.98093 4.30041 10.0284 4.30122 10.0758C2.40285 10.5786 1 12.3539 1 14.4667C1 16.9704 2.96995 19 5.4 19H17.5C20.5376 19 23 16.4629 23 13.3333C23 10.9231 21.5395 8.86433 19.4806 8.0452C18.6584 4.5753 15.6211 2 12 2Z"
				fill="currentColor"
			/>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M12 22V13M12 13L8.5 16.5M12 13L15.5 16.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C7.4446 1.25 3.76319 4.9413 3.55893 9.53106C1.61442 10.2944 0.25 12.225 0.25 14.4667C0.25 17.3633 2.53479 19.75 5.4 19.75H10V17.8284L9.91421 17.9142C9.13317 18.6953 7.86684 18.6953 7.08579 17.9142C6.30474 17.1332 6.30474 15.8668 7.08579 15.0858L10.5858 11.5858C11.3668 10.8047 12.6332 10.8047 13.4142 11.5858L16.9142 15.0858C17.6953 15.8668 17.6953 17.1332 16.9142 17.9142C16.1332 18.6953 14.8668 18.6953 14.0858 17.9142L14 17.8284V19.75H17.5C20.9727 19.75 23.75 16.8559 23.75 13.3333C23.75 10.7563 22.268 8.52279 20.1145 7.50352C19.095 3.90344 15.8601 1.25 12 1.25ZM16.0303 15.9697L12.5303 12.4697C12.2374 12.1768 11.7626 12.1768 11.4697 12.4697L7.96967 15.9697C7.67678 16.2626 7.67678 16.7374 7.96967 17.0303C8.26256 17.3232 8.73744 17.3232 9.03033 17.0303L11.25 14.8107V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V14.8107L14.9697 17.0303C15.2626 17.3232 15.7374 17.3232 16.0303 17.0303C16.3232 16.7374 16.3232 16.2626 16.0303 15.9697Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C13.9084 2 15.6547 2.69815 17 3.85431M12 22V13M12 13L8.5 16.5M12 13L15.5 16.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M12 22V13M12 13L8.5 16.5M12 13L15.5 16.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M3.55893 9.53106C3.76319 4.9413 7.4446 1.25 12 1.25C15.8601 1.25 19.095 3.90344 20.1145 7.50352C22.268 8.52279 23.75 10.7563 23.75 13.3333C23.75 16.8559 20.9727 19.75 17.5 19.75H14V17.8284L14.0858 17.9142C14.8668 18.6953 16.1332 18.6953 16.9142 17.9142C17.6953 17.1332 17.6953 15.8668 16.9142 15.0858L13.4142 11.5858C12.6332 10.8047 11.3668 10.8047 10.5858 11.5858L7.08579 15.0858C6.30474 15.8668 6.30474 17.1332 7.08579 17.9142C7.86684 18.6953 9.13317 18.6953 9.91421 17.9142L10 17.8284V19.75H5.4C2.53479 19.75 0.25 17.3633 0.25 14.4667C0.25 12.225 1.61442 10.2944 3.55893 9.53106Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4697 12.4697C11.7626 12.1768 12.2374 12.1768 12.5303 12.4697L16.0303 15.9697C16.3232 16.2626 16.3232 16.7374 16.0303 17.0303C15.7374 17.3232 15.2626 17.3232 14.9697 17.0303L12.75 14.8107V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V14.8107L9.03033 17.0303C8.73744 17.3232 8.26256 17.3232 7.96967 17.0303C7.67678 16.7374 7.67678 16.2626 7.96967 15.9697L11.4697 12.4697Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
